var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.76219 3C5.34125 3 5 3.34125 5 3.76219V4.25H2C1.58579 4.25 1.25 4.58579 1.25 5V6.17157C1.25 8.1815 2.04844 10.1091 3.46967 11.5303C3.76256 11.8232 4.23744 11.8232 4.53033 11.5303C4.82322 11.2374 4.82322 10.7626 4.53033 10.4697C3.3904 9.32974 2.75 7.78367 2.75 6.17157V5.75H5V7.92893C5 11.7294 7.6176 14.9881 11.25 15.8571V18H8.59342C8.14421 18 7.75013 18.2995 7.6299 18.7324L7.20833 20.25H3C2.58579 20.25 2.25 20.5858 2.25 21C2.25 21.4142 2.58579 21.75 3 21.75H21C21.4142 21.75 21.75 21.4142 21.75 21C21.75 20.5858 21.4142 20.25 21 20.25H16.7917L16.3701 18.7324C16.2499 18.2995 15.8558 18 15.4066 18H12.75V15.8571C16.3824 14.9881 19 11.7294 19 7.92893V5.75H21.25V6.17157C21.25 7.78367 20.6096 9.32974 19.4697 10.4697C19.1768 10.7626 19.1768 11.2374 19.4697 11.5303C19.7626 11.8232 20.2374 11.8232 20.5303 11.5303C21.9516 10.1091 22.75 8.1815 22.75 6.17157V5C22.75 4.58579 22.4142 4.25 22 4.25H19V3.76219C19 3.34125 18.6588 3 18.2378 3H5.76219Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContest);
export default __webpack_public_path__ + "static/media/contest.06e0f69b7eb6158edbbcd9c404b16840.svg";
export { ForwardRef as ReactComponent };